<template>
  <b-sidebar
    id="sidebar-command-add-new-product"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Ajouter produit</h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <!-- Body -->
      <b-form class="p-2" @submit.prevent>
        <!-- code -->
        <b-form-group label="Code" label-for="v-code">
          <b-form-input
            id="v-code"
            placeholder="000001"
            v-model="product.code"
          />
        </b-form-group>

        <!-- name -->
        <b-form-group label="Label" label-for="v-label">
          <b-form-input
            id="v-label"
            placeholder="Nom du produit"
            v-model="product.label"
          />
        </b-form-group>

        <!-- quantity -->
        <b-form-group label="Quantité" label-for="v-quantity">
          <b-form-input
            id="v-quantity"
            placeholder="5"
            v-model="product.quantity"
          />
        </b-form-group>

        <!-- Prix ht -->
        <b-form-group label="Prix hors tax" label-for="v-pth">
          <b-form-input
            id="v-pth"
            placeholder="1000"
            v-model="product.priceWithoutTaxes"
          />
        </b-form-group>
        <b-form-group label="Tax" label-for="v-tax">
          <b-form-input
            id="v-tax"
            placeholder="10"
            v-model="product.valueAddedTax"
          />
        </b-form-group>
        <b-form-group label="Remise" label-for="v-remise">
          <b-form-input
            id="v-remise"
            placeholder="10"
            v-model="product.discount"
          />
        </b-form-group>

        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="addProduct(), hide"
          >
            Ajouter produits
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="hide"
          >
            Fermer
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import axios from "axios";

import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BButton,
} from "bootstrap-vue";
import { ref } from "@vue/composition-api";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    ToastificationContent,
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    vSelect,
  },
  directives: {
    Ripple,
  },
  setup() {
    const product = ref({
      code: "",
      label: "",
      quantity: "",
      priceWithoutTaxes: "",
      valueAddedTax: "",
      discount: "",
    });

    return {
      product,
    };
  },
  methods: {
    addProduct() {
      this.product.createdBy= JSON.parse(localStorage.getItem("userData"))._id,
      axios
        .post(
          "https://management-projects.herokuapp.com/api/products",
          this.product
        )
        .then((response) => {
          console.log(response);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Produit bien ajouté",
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.$emit("update-product", this.product);
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Erreur lors de l'ajout du produit",
              icon: "EditIcon",
              variant: "danger",
            },
          });
          this.errorMessage = error.message;
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
